export const listQuickView = {
  data: [
    {
      partnerId: 8,
      code: "AXA",
      name: "AXA",
    },
    {
      partnerId: 26,
      code: "BAOVIET",
      name: "Bao Viet",
    },
    {
      partnerId: 40,
      code: "GEGI",
      name: "Great Eastern General Insurance",
    },
    {
      partnerId: 7,
      code: "LOLI",
      name: "Lojaya Life Insurance",
    },
    {
      partnerId: 34,
      code: "MSIG",
      name: "MSIG",
    },
    {
      partnerId: 46,
      code: "MSIGVN",
      name: "MSIG Vietnam",
    },
    {
      partnerId: 2,
      code: "SIMAS",
      name: "Simas Insurtech",
    },
    {
      partnerId: 6,
      code: "ALLIANZ",
      name: "Zurich",
    },
  ],
  meta: {
    total: 8,
  },
  status: "200",
  message: "success list partners",
};

export const listProductCategory = {
  data: [
    {
      _label: "TEXT_LABEL_CAR",
      name: "Car",
      value: "CAR",
      default: false,
    },
    // {
    //   _label: "TEXT_LABEL_INDIVIDUAL",
    //   name: "Individual",
    //   value: "INDIVIDUAL",
    //   default: false,
    // },
    {
      _label: "TEXT_LABEL_MOTOR",
      name: "Motor",
      value: "MOTOR",
      default: false,
    },
    // {
    //   _label: "TEXT_LABEL_PROPERTY",
    //   name: "Property",
    //   value: "PROPERTY",
    //   default: false,
    // },
  ],
  meta: {
    total: 2,
  },
  status: "200",
  message: "success list product category",
};
